// src/pages/Experience.js
import React from "react";
import { Container, Card, Row, Col, ListGroup } from "react-bootstrap";

const experiences = [
  {
    company: "Astrapia Consulting LLP (SourceEase HR Services)",
    duration: "Feb 2024 – Present",
    role: "Software Engineer",
    location: "Noida",
    points: [
      "Designed and implemented backend functionalities for a multi-brand content management platform using Core Java, J2EE, and Adobe Experience Manager (AEM).",
      "Integrated third-party APIs and services within the AEM platform using Java, enhancing system capabilities and enabling new business functionalities.",
      "Assisted the frontend team in integrating backend APIs with React.js, ensuring efficient data flow.",
      "Conducted in-depth debugging and troubleshooting of Java code to resolve backend issues.",
      "Collaborated with DevOps teams to deploy Java-based backend services, ensuring 99.9% uptime and scalability.",
    ],
  },
  {
    company: "SourceEase HR Services",
    duration: "Oct 2022 – Feb 2024",
    role: "Software Engineer",
    location: "New Delhi",
    points: [
      "Led full product development cycles including story creation, documentation, and release planning.",
      "Mentored junior developers, managed onboarding and streamlined team operations.",
      "Developed REST APIs and integrated them with databases, third-party services, and cloud products.",
      "Supported frontend teams using AngularJS and ensured seamless API integration.",
      "Handled database design, migrations, and wrote complex SQL queries.",
      "Coordinated testing with QA teams and provided production support for issue resolution.",
    ],
  },
];

const projects = [
  {
    title: "The Center",
    company: "Astrapia Consulting LLP",
    role: "Java Developer",
    duration: "Feb 2024 – Present",
    tech: "Java, J2EE, AEM, React.js, Apache Jackrabbit Oak, CRXDE Lite, JCR API, HTTP Servlets, OSGi",
    points: [
      "Developed end-to-end functionalities and implemented new features for multiple brands managed within The Center using Adobe Experience Manager (AEM).",
      "Leveraged HTTP Servlets and Apache Jackrabbit Oak (based on JCR) to create scalable and efficient solutions for content storage and retrieval.",
      "Collaborated with the frontend team by providing backend APIs and ensuring seamless communication between React.js-based UI and Java backend services.",
      "Created custom Java-based workflows and schedulers to automate content management tasks, improving operational efficiency.",
      "Built custom utilities and libraries in Java to streamline development processes and enhance platform functionality.",
    ],
  },
  {
    title: "UrJobMart",
    company: "SourceEase HR Services",
    role: "Java Backend Developer",
    duration: "Oct 2022 – Feb 2024",
    tech: "Java, Spring Boot, Hibernate, PostgreSQL, AWS (SQS, S3, Cognito), ElasticSearch",
    points: [
      "Developed an extensive hiring platform using Java, Spring Boot, Hibernate, and PostgreSQL database to enhance recruitment and candidate management.",
      "Integrated AWS services such as SQS, S3 storage, ElasticSearch, and Cognito for secure and scalable architecture.",
      "Built RESTful APIs to integrate with external systems, with SQS used for async processing, and S3 for storing files like images and CVs.",
      "Designed and optimized PostgreSQL database schemas, including complex queries, stored procedures, and views.",
      "Implemented secure user authentication and authorization using JWT Tokens and AWS Cognito.",
    ],
  },
];

const Experience = () => {
  return (
    <Container className="mt-4">
      <h2 className="mb-4 text-white text-center">💼 Work Experience</h2>

      {experiences.map((exp, idx) => (
        <Card
          key={idx}
          className="bg-dark text-white shadow mb-4"
          style={{ borderLeft: "5px solid #0dcaf0" }}
        >
          <Card.Body>
            <Row className="align-items-center">
              <Col>
                <Card.Title className="fs-4 fw-bold">{exp.role}</Card.Title>
                <Card.Subtitle className="mb-2 text-info">
                  {exp.company}
                </Card.Subtitle>
                <p className="mb-1">
                  <strong>Location:</strong> {exp.location}
                </p>
                <p className="mb-2">
                  <strong>Duration:</strong> {exp.duration}
                </p>
                <ListGroup variant="flush">
                  {exp.points.map((point, i) => (
                    <ListGroup.Item
                      key={i}
                      className="bg-dark text-white border-0 ps-3"
                    >
                      • {point}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}

      <h3 className="text-white mt-5 mb-3">🚀 Project Experience</h3>

      {projects.map((proj, idx) => (
        <Card
          key={idx}
          className="bg-dark text-white shadow mb-4"
          style={{ borderLeft: "5px solid #198754" }}
        >
          <Card.Body>
            <Card.Title className="fs-5 text-success">{proj.title}</Card.Title>
            <Card.Subtitle className="mb-2 text-info">
              {proj.company} | {proj.role}
            </Card.Subtitle>
            <p className="mb-1">
              <strong>Duration:</strong> {proj.duration}
            </p>
            <p className="mb-2">
              <strong>Tech Stack:</strong> {proj.tech}
            </p>
            <ListGroup variant="flush">
              {proj.points.map((point, i) => (
                <ListGroup.Item
                  key={i}
                  className="bg-dark text-white border-0 ps-3"
                >
                  • {point}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
};

export default Experience;
